import { Formik } from 'formik'

import { ModalWrapper } from 'src/components/modal-wrapper'

import { IRewardPointsForm } from 'src/types'
import { rewardPointSchema } from 'src/common/validations'

import { useStyles } from '../../styles'
import { RewardPointForm } from '../form.component'
import { useUpdateRewardPoint } from 'src/hooks/reward-points'
import { useItemsRemoveConfirm } from 'src/hooks'
import { EConfirmModalTitles } from 'src/constants'

interface IProps {
  open: boolean
  handleClose: () => void
  id: string
  initial: IRewardPointsForm
}

export const UpdateRewardPointForm = ({ open, handleClose, id, initial }: IProps) => {
  const classes = useStyles()
  const { mutateAsync } = useUpdateRewardPoint()

  const { setRemoveConfirm } = useItemsRemoveConfirm()

  const handleUpdateItem = async (values: IRewardPointsForm) => {
    if (!values) return

    handleClose()

    setRemoveConfirm({
      handleConfirm: async () => {
        await mutateAsync({ ...values, id })
      },
      customModal: {
        title: EConfirmModalTitles.UPDATE,
      },
      itemsTitles: [],
      itemsDetails: [
        { text: values.name, title: 'Name' },
        { text: values.type, title: 'Type' },
      ],
      itemsRelations: [],
      itemsType: '',
    })
  }

  return (
    <ModalWrapper className={classes.modalWrapper} open={open} onClose={handleClose}>
      <Formik
        initialValues={initial}
        validationSchema={rewardPointSchema}
        onSubmit={handleUpdateItem}
      >
        <RewardPointForm isUpdate />
      </Formik>
    </ModalWrapper>
  )
}
